import type { SeatingTable } from '../types/dayof';

export const templateTimelineEvents = [
  {
    time: '14:00',
    event: 'Vendor Setup Begins',
    status: 'pending' as const,
    duration: 90,
    responsible: ['Wedding Planner', 'Venue Coordinator'],
    notes: 'All vendors should arrive and begin setup',
  },
  {
    time: '15:30',
    event: 'Bridal Party Photos',
    status: 'pending' as const,
    duration: 60,
    location: 'Garden Area',
    responsible: ['Photographer'],
    notes: 'Pre-ceremony photos with bridal party',
  },
  {
    time: '16:00',
    event: 'Guest Arrival',
    status: 'pending' as const,
    duration: 30,
    responsible: ['Ushers', 'Wedding Planner'],
    notes: 'Welcome drinks and seating assistance',
  },
  {
    time: '16:30',
    event: 'Ceremony Begins',
    status: 'pending' as const,
    duration: 45,
    location: 'Main Ceremony Area',
    responsible: ['Officiant', 'Musician'],
    notes: 'Processional music starts 5 minutes early',
  },
  {
    time: '17:15',
    event: 'Cocktail Hour',
    status: 'pending' as const,
    duration: 75,
    location: 'Garden Terrace',
    responsible: ['Bartender', 'Catering Staff'],
    notes: 'Couple photos during cocktail hour',
  },
  {
    time: '18:30',
    event: 'Reception Begins',
    status: 'pending' as const,
    duration: 30,
    location: 'Main Reception Hall',
    responsible: ['MC', 'Wedding Planner'],
    notes: 'Grand entrance and welcome speech',
  },
  {
    time: '19:00',
    event: 'Dinner Service',
    status: 'pending' as const,
    duration: 90,
    responsible: ['Catering Team', 'Servers'],
    notes: 'Three-course plated dinner service',
  },
  {
    time: '20:30',
    event: 'Speeches & Toasts',
    status: 'pending' as const,
    duration: 30,
    responsible: ['MC', 'Best Man', 'Maid of Honor'],
    notes: 'Keep speeches to 3-4 minutes each',
  },
  {
    time: '21:00',
    event: 'First Dance',
    status: 'pending' as const,
    duration: 15,
    responsible: ['DJ', 'Lighting Technician'],
    notes: 'Special lighting for first dance',
  },
  {
    time: '21:15',
    event: 'Dancing & Celebration',
    status: 'pending' as const,
    duration: 165,
    responsible: ['DJ', 'MC'],
    notes: 'Open dance floor and party music',
  },
];

export const templateVendors = [
  {
    name: 'Capture Moments Photography',
    contact: '+94 77 123 4567',
    role: 'Photographer',
    arrival_time: '14:00',
    setup_time: '14:00 - 14:30',
    status: 'pending' as const,
    notes: 'Will need access to bridal suite at 13:30',
  },
  {
    name: 'Melody Makers DJ Service',
    contact: '+94 77 234 5678',
    role: 'DJ/Music',
    arrival_time: '15:00',
    setup_time: '15:00 - 16:00',
    status: 'pending' as const,
    notes: 'Sound check at 16:15 before ceremony',
  },
  {
    name: 'Gourmet Catering Co.',
    contact: '+94 77 345 6789',
    role: 'Catering',
    arrival_time: '14:30',
    setup_time: '14:30 - 16:00',
    status: 'pending' as const,
    notes: 'Kitchen access required from 14:00',
  },
  {
    name: 'Bloom & Blossom Florists',
    contact: '+94 77 456 7890',
    role: 'Florist',
    arrival_time: '13:00',
    setup_time: '13:00 - 15:30',
    status: 'pending' as const,
    notes: 'Ceremony decorations first, then reception setup',
  },
  {
    name: 'Elegant Events Decoration',
    contact: '+94 77 567 8901',
    role: 'Decorator',
    arrival_time: '12:00',
    setup_time: '12:00 - 15:00',
    status: 'pending' as const,
    notes: 'Lighting setup requires early access',
  },
];

export const sampleTables: SeatingTable[] = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  capacity: 8,
  shape: 'round' as const,
  guests: [],
  position: { x: (i % 4) * 200 + 100, y: Math.floor(i / 4) * 150 + 100 },
}));
